/**
 * @generated SignedSource<<073e7d3aac053da8af5c93c8a297b31b>>
 * @relayHash a1232aab5ef9e6659ae067c93a9169aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 076209f08f2315ef3dc68a6106e497924279b6f13378b7488e91c34481458fd4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type uiConnectedRepositoryListQuery$variables = {
  first: number;
  projectId: string;
};
export type uiConnectedRepositoryListQuery$data = {
  readonly graphStore: {
    readonly projectAssociatedRepo: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "DevOpsRepository";
          readonly name: string | null | undefined;
          readonly providerId: string | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type uiConnectedRepositoryListQuery = {
  response: uiConnectedRepositoryListQuery$data;
  variables: uiConnectedRepositoryListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiConnectedRepositoryListQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedRepo",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "DevOpsRepository"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiConnectedRepositoryListQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedRepo",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ],
                        "type": "DevOpsRepository"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "076209f08f2315ef3dc68a6106e497924279b6f13378b7488e91c34481458fd4",
    "metadata": {},
    "name": "uiConnectedRepositoryListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1bf7812285ed8ed625f26394df73556d";

export default node;
